module.exports = __webpack_public_path__ + "furniture.0305d53dd4367efe1271.ttf";


//////////////////
// WEBPACK FOOTER
// C:/Users/INMOGR/Desktop/Angular Project/src/assets/fonts/line-icons-pro/furniture/webfont/furniture.ttf
// module id = ../../../../../src/assets/fonts/line-icons-pro/furniture/webfont/furniture.ttf
// module chunks = styles